import Mock from "mockjs";
import loginApi from "./login.js";
// import authApi from "./auth";

// 设置200-2000毫秒延时请求数据
Mock.setup({
  timeout: "500",
});

// 登录相关
// 拦截的是 /home/getData
Mock.mock(/\/home\/login/, "get", loginApi.login);

// 用户权限相关
// Mock.mock(/\/user\/getUser/, "get", userApi.getUserList);
// Mock.mock(/\/user\/del/, "get", userApi.deleteUser);
// Mock.mock(/\/user\/batchremove/, "get", userApi.batchremove);
// Mock.mock(/\/user\/add/, "post", userApi.createUser);
// Mock.mock(/\/user\/edit/, "post", userApi.updateUser);
// Mock.mock(/\/home\/getData/, "get", homeApi.getStatisticalData);
